import React from 'react';
import { WindowSize, WindowPreset } from '../Window/windowTypes';

// Forms
import ClienteForm from '../../pages/ClienteForm';
import OrcamentoForm from '../../pages/OrcamentoForm';
import VendedorForm from '../../pages/VendedorForm';
import FornecedorForm from '../../pages/FornecedorForm';
import KitForm from '../../pages/KitForm';
import CidadeForm from '../../pages/CidadeForm';
import TagForm from '../../pages/TagForm';
import ContaFinanceiraForm from '../../pages/ContaFinanceiraForm';
import ContaReceberForm from '../../pages/ContaReceberForm';
import ContaPagarForm from '../../pages/ContaPagarForm';
import RecebimentoForm from '../../pages/RecebimentoForm';
import PagamentoForm from '../../pages/PagamentoForm';
import MovimentacaoForm from '../../pages/MovimentacaoForm';
import BoletoForm from '../../pages/BoletoForm';
import BaixaBoletoForm from '../../pages/BaixaBoletoForm';
import LogComunicacaoGridViewer from '../../pages/LogComunicacaoGridViewer';
import BoletoLogGridViewer from '../../pages/BoletoLogGridViewer';
import LogDetailViewer from '../../pages/LogDetailViewer';
import GatewayPagamentoGridViewer from '../../pages/GatewayPagamentoGridViewer';
import WebhookLogGridViewer from '../../pages/WebhookLogGridViewer';
import InterCobrancaGridViewer from '../../pages/InterCobrancaGridViewer';
import InterCallbackGridViewer from '../../pages/InterCallbackGridViewer';
import GatewayPagamentoForm from '../../pages/GatewayPagamentoForm';
import ConciliacaoForm from '../../pages/ConciliacaoForm';
import ProvisaoForm from '../../pages/ProvisaoForm';
import SitePostForm from '../../pages/SitePostForm';
import ContratoForm from '../../pages/ContratoForm';
import ContratoFinanceiroForm from '../../pages/ContratoFinanceiroForm';
import MarcaForm from '../../pages/MarcaForm';
import OverloadForm from '../../pages/OverloadForm';
import CategoriaForm from '../../pages/CategoriaForm';
import CaracteristicaForm from '../../pages/CaracteristicaForm';
import DepositoForm from '../../pages/DepositoForm';
import ProdutoForm from '../../pages/ProdutoForm';
import EstoqueMovimentoForm from '../../pages/EstoqueMovimentoForm';
import EmitenteForm from '../../pages/EmitenteForm';
import NotaFiscalForm from '../../pages/NotaFiscalForm';
import KitLogGridViewer from '../../pages/KitLogGridViewer';
import UsinaForm from '../../pages/UsinaForm';
import UsinaContratoForm from '../../pages/UsinaContratoForm';
import UsinaDetalheViewer from '../../pages/UsinaDetalheViewer';
import UsinaHistoricoGridViewer from '../../pages/UsinaHistoricoGridViewer';
import UsinaVinculosGridViewer from '../../pages/UsinaVinculosGridViewer';
import TipoTarefaForm from '../../pages/TipoTarefaForm';
import TemplateForm from '../../pages/TemplateForm';
import CampoForm from '../../pages/CampoForm';
import TarefaForm from '../../pages/TarefaForm';
import ObraForm from '../../pages/ObraForm';
import DispositivoForm from '../../pages/DispositivoForm';
import PerfilForm from '../../pages/PerfilForm';
import UsuarioForm from '../../pages/UsuarioForm';
import InstaladorForm from '../../pages/InstaladorForm';
import PessoaForm from '../../pages/PessoaForm';
import ContratoInstaladorForm from '../../pages/ContratoInstaladorForm';
import ContratoModeloForm from '../../pages/ContratoModeloForm';
import ContratoModeloEspacoForm from '../../pages/ContratoModeloEspacoForm';
import ContratoVersaoForm from '../../pages/ContratoVersaoForm';
import ContratoAssinaturaForm from '../../pages/ContratoAssinaturaForm';
import ContratoDocumentoViewer from '../../pages/ContratoDocumentoViewer';

// Grid genérico
import Grid from './Grid';

export interface RouteConfig {
    component: React.ComponentType<any>;
    type: 'form' | 'grid';
    title?: string;
    windowSize?: WindowSize | WindowPreset;
}

// Registry de componentes por entidade
const componentRegistry: Record<string, {
    form?: React.ComponentType<any>;
    title?: string;
    windowSize?: WindowSize | WindowPreset;
}> = {
    // Cliente virou papel: identidade e endereço saíram para a tela de Pessoa e
    // sobraram pessoa, vendedor dono, cliente PJ e a grade de unidades consumidoras.
    // 'md' (750x500) e não 'lg': é a grade de UC que pede a largura, a mesma razão do
    // 'md' do fornecedor. Não usa 'xl' porque o dono reclamou de modal grande.
    'cliente': { form: ClienteForm, title: 'Cliente', windowSize: 'md' },
    'orcamento': { form: OrcamentoForm, title: 'Orçamento', windowSize: 'xl' },
    // Vendedor e fornecedor viraram papel: a identidade saiu para a tela de Pessoa e
    // sobrou pouca coisa, então os dois encolheram. Vendedor é pessoa, login, acesso
    // e supervisor; fornecedor é pessoa, plataforma e contas bancárias, e é a grade
    // de contas que ainda pede a largura do 'md'.
    'vendedor': { form: VendedorForm, title: 'Vendedor', windowSize: 'sm' },
    'fornecedor': { form: FornecedorForm, title: 'Fornecedor', windowSize: 'md' },
    'kit': { form: KitForm, title: 'Kit', windowSize: 'xl' },
    'cidade': { form: CidadeForm, title: 'Cidade', windowSize: 'sm' },
    'tag': { form: TagForm, title: 'Tag', windowSize: 'sm' },
    'contafinanceira': { form: ContaFinanceiraForm, title: 'Conta Financeira' },
    'contareceber': { form: ContaReceberForm, title: 'Conta a Receber' },
    'contapagar': { form: ContaPagarForm, title: 'Conta a Pagar' },
    'recebimento': { form: RecebimentoForm, title: 'Recebimento' },
    'pagamento': { form: PagamentoForm, title: 'Pagamento' },
    'movimentacao': { form: MovimentacaoForm, title: 'Movimentação' },
    'boleto': { form: BoletoForm, title: 'Emitir Boleto', windowSize: 'lg' },
    'baixaboleto': { form: BaixaBoletoForm, title: 'Registrar Pagamento', windowSize: 'sm' },
    'logcomunicacao': { form: LogComunicacaoGridViewer, title: 'Log de Comunicação', windowSize: 'lg' },
    'boletolog':          { form: BoletoLogGridViewer,          title: 'Log do Boleto',         windowSize: 'xl' },
    'kitlog':             { form: KitLogGridViewer,             title: 'Log de Alterações',     windowSize: 'xl' },
    'logdetalhe':         { form: LogDetailViewer,              title: 'Detalhes do Log',        windowSize: 'lg' },
    'gatewaypagamentogrid': { form: GatewayPagamentoGridViewer, title: 'Gateways de Pagamento',  windowSize: 'xl' },
    'webhookloggrid':     { form: WebhookLogGridViewer,         title: 'Webhooks Recebidos',     windowSize: 'xl' },
    'intercobrancagrid':  { form: InterCobrancaGridViewer,      title: 'Consulta Inter',         windowSize: 'xl' },
    'intercallbackgrid':  { form: InterCallbackGridViewer,      title: 'Callbacks Inter',        windowSize: 'xl' },
    'gatewaypagamento': { form: GatewayPagamentoForm, title: 'Gateway de Pagamento', windowSize: 'xl' },
    'conciliacao': { form: ConciliacaoForm, title: 'Conciliação' },
    'provisao': { form: ProvisaoForm, title: 'Provisão' },
    'sitepost': { form: SitePostForm, title: 'Post do Site' },
    'contrato': { form: ContratoForm, title: 'Contrato', windowSize: 'xl' },
    'contratofinanceiro': { form: ContratoFinanceiroForm, title: 'Financeiro', windowSize: 'lg' },
    'marca': { form: MarcaForm, title: 'Marca', windowSize: 'sm' },
    'overload': { form: OverloadForm, title: 'Overload', windowSize: 'sm' },
    'categoria': { form: CategoriaForm, title: 'Categoria', windowSize: 'md' },
    'caracteristica': { form: CaracteristicaForm, title: 'Característica', windowSize: 'md' },
    'deposito': { form: DepositoForm, title: 'Depósito', windowSize: 'sm' },
    'produto': { form: ProdutoForm, title: 'Produto', windowSize: 'xl' },
    'estoque': { form: EstoqueMovimentoForm, title: 'Movimento de Estoque', windowSize: 'md' },
    'emitente': { form: EmitenteForm, title: 'Emitente', windowSize: 'lg' },
    'notafiscal': { form: NotaFiscalForm, title: 'Nota Fiscal', windowSize: 'xl' },

    // App de campo (módulo Obras)
    'tartipo':       { form: TipoTarefaForm,    title: 'Tipo de Tarefa',        windowSize: 'md' },
    // Os campos saíram do form do template para um grid filho, alcançado pela ação
    // "Campos": o template ficou com cinco campos e cabe no 'sm'; o campo tem chave,
    // título, tipo, ajuda, opções e validação, e pede o 'md'.
    'tartemplate':   { form: TemplateForm,      title: 'Template de Checklist', windowSize: 'sm' },
    'tarcampo':      { form: CampoForm,         title: 'Campo do Template',     windowSize: 'md' },
    // 'auto' nos dois: o form da tarefa são oito campos em duas colunas e o painel da
    // obra é uma lista de linhas de largura conhecida. Tela cheia sobrava dos dois lados.
    'tartarefa':     { form: TarefaForm,        title: 'Tarefa',                windowSize: 'auto' },
    // Painel da obra: a obra é o contrato, e o que se lê aqui são as tarefas dele
    // agrupadas por trilha, cada uma abrindo o próprio form.
    'tarobra':       { form: ObraForm,          title: 'Obra',                  windowSize: 'auto' },
    'undispositivo': { form: DispositivoForm,   title: 'Dispositivo',           windowSize: 'md' },

    // Cadastro unificado: Pessoa, o papel Instalador, e o Perfil de acesso
    // Sem windowSize: o form de pessoa herdou a disposição que o de cliente tinha
    // antes de virar papel (identidade mais endereço), e é ele que pede esse tamanho
    // agora. Instalador é pequeno, só pessoa, ativo e PIX.
    'unpessoa':      { form: PessoaForm,        title: 'Pessoa', windowSize: { width: 900 } },
    'uninstalador':  { form: InstaladorForm,    title: 'Instalador',            windowSize: 'sm' },
    'unperfil':      { form: PerfilForm,        title: 'Perfil',                windowSize: 'lg' },
    // 'lg' (900x600) e nao 'md' (750x500) desde que a tela virou duas colunas: a
    // coluna dos campos fica com 7/12 da largura, e nos 750 do 'md' o par perfil +
    // tipo nao caberia; a altura de 500 tambem nao leva os campos ao lado do QR de
    // 190px sem rolagem. Nao usa 'xl': o dono reclamou de modal grande.
    'unusuario':     { form: UsuarioForm,       title: 'Usuário',               windowSize: 'lg' },

    // Contrato do instalador. Tamanhos escolhidos pelo que cada tela precisa, e não
    // por reflexo: 'md' para o cadastro (6 campos), 'lg' para o modelo (textarea do
    // corpo mais a tabela de espaços), 'sm' para gerar versão e anexar assinado, que
    // são um campo e um arquivo. O visualizador do documento não é preset: 860x820 é
    // a largura de uma folha A4 a 100% mais a barra de rolagem, e não a tela inteira.
    'uncontrato':           { form: ContratoInstaladorForm,  title: 'Contrato do Instalador', windowSize: 'md' },
    // O modelo mantém o 'lg' pelo textarea do corpo; os espaços saíram para um grid
    // filho, e o form de cada um é nome, papel, página e quatro medidas: 'sm'.
    'uncontratomodelo':      { form: ContratoModeloForm,      title: 'Modelo de Contrato',     windowSize: 'xl' },
    'uncontratomodeloespaco': { form: ContratoModeloEspacoForm, title: 'Espaço de Assinatura', windowSize: 'sm' },
    'uncontratoversao':     { form: ContratoVersaoForm,      title: 'Gerar versão',           windowSize: 'sm' },
    'uncontratoassinatura': { form: ContratoAssinaturaForm,  title: 'Anexar assinado',        windowSize: 'sm' },
    'uncontratodocumento':  { form: ContratoDocumentoViewer, title: 'Documento do contrato',  windowSize: { width: 860, height: 820 } },

    // Monitoramento de usinas
    'usina':         { form: UsinaForm,          title: 'Usina',              windowSize: 'md' },
    'usinacontrato': { form: UsinaContratoForm,  title: 'Vínculo com Projeto', windowSize: 'md' },
    'usinadetalhe':  { form: UsinaDetalheViewer, title: 'Detalhes da Usina',  windowSize: 'xl' },
    'usinahistorico': { form: UsinaHistoricoGridViewer, title: 'Histórico de Geração', windowSize: 'xl' },
    'usinavinculos':  { form: UsinaVinculosGridViewer,  title: 'Vínculos da Usina',    windowSize: 'xl' },
};

// Ações que não precisam de componente (executam direto)
const directActions = ['delete', 'export', 'print'];

export interface ParsedRoute {
    module: string;
    entity: string;
    action: string;
}

export function parseRoute(route: string): ParsedRoute {
    const match = route.match(/^(\w+)_(\w+)_(\w+)$/);
    if (!match) {
        throw new Error(`Invalid route format: ${route}. Expected: module_entity_action (e.g., un_cliente_add)`);
    }
    return {
        module: match[1],
        entity: match[2],
        action: match[3]
    };
}

export function resolveRoute(route: string): RouteConfig | null {
    const { entity, action } = parseRoute(route);

    // Ações diretas não precisam de componente
    if (directActions.includes(action)) {
        return null;
    }

    const entry = componentRegistry[entity];

    // Grid (listagem)
    if (action === 'list') {
        return {
            component: Grid,
            type: 'grid',
            title: entry?.title ? `${entry.title}s` : entity
        };
    }

    // Form (add/edit)
    if (['add', 'edit', 'view'].includes(action)) {
        if (!entry?.form) {
            console.warn(`No form registered for entity: ${entity}`);
            return null;
        }
        return {
            component: entry.form,
            type: 'form',
            title: action === 'add'
                ? `Novo ${entry.title || entity}`
                : action === 'edit'
                    ? `Editar ${entry.title || entity}`
                    : entry.title || entity,
            windowSize: entry.windowSize
        };
    }

    console.warn(`Unknown action: ${action} for route: ${route}`);
    return null;
}

export function getEntityTitle(entity: string): string {
    return componentRegistry[entity]?.title || entity;
}

export function registerComponent(entity: string, config: { form?: React.ComponentType<any>; title?: string }) {
    componentRegistry[entity] = { ...componentRegistry[entity], ...config };
}

export default componentRegistry;
